import { base } from "./base";
import { errorToastHook } from "./hooks/errorToast";
import { localTokenRefreshHook } from "./hooks/tokenRefresh";
import { makeAuthHook } from "./hooks/auth";

const localAuthHook = makeAuthHook(() => localStorage.getItem("token"));

// Silent authenticated instance — no loader, auth + 403 refresh only
export const httpAuthBackground2 = base.extend({
  hooks: {
    afterResponse: [localTokenRefreshHook],
    beforeError: [errorToastHook],
    beforeRequest: [localAuthHook],
  },
});
